import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTagComponent } from "./med-icon-tag.component";

@NgModule({
  declarations: [
    MedIconTagComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTagComponent,
  ],
})
export class MedIconTagModule { }
